import React from 'react';
import './Position.css';

import { Button } from '../../components';

import { FaMapMarkerAlt, FaMoneyBill } from 'react-icons/fa';

import { Link } from 'react-router-dom';

const Position = (props) => {

  // Destructuring props to get the necessary details for each job position
  const { id, timing, title, location, salary, position } = props;

  return (

    /* Container for each job position item */
    <div className='position-item' key={id}>

      <span>{timing}</span> {/* Display job timing */}

      {/* Link to the individual job position page */}
      <Link
        to={{
          pathname: '/Careers/' + title,  // Navigate to specific job position page
        }}
        state={position}  // Pass position details to the linked page
        className='main-heading' >
        <h2>{title}</h2> {/* Display job title */}
      </Link>

      <div className='details'>
        <h3><FaMapMarkerAlt className='icon' /><span>{location}</span></h3> {/* Location of the job */}
        <h3><FaMoneyBill className='icon' /><span>{salary}</span></h3> {/* Salary for the job */}
      </div>

      <Button link={'CareerForm'} title={'Apply Now'} /> {/* 'Apply Now' button which redirects to the career form */}

    </div>

  );
};

export default Position;